import React, { Component } from "react";
import styles from "./reportContructor.module.scss";
import { withReportsList } from "../../../shared/containers/containerReportsList";
import Scrollbars from "react-custom-scrollbars-2";
import { withCustomReport } from "../../../shared/containers/containerCustomReport";
import ModalConfirmWindow from "../../Contents/ModalComponents/ModalConfirmWindow";
import ReportConstructorCreatePanel from "./ReportConstructorCreatePanel";

class ReportConstructorPaternList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isPatternListOpen: true,
      isModalConfirmOpen: false,
      selectedReport: null,
    };
  }

  onSelected(selectedReport) {
    this.setState({ selectedReport, isModalConfirmOpen: false });
  }

  onModalConfirmOpen(e) {
    this.setState({ isModalConfirmOpen: true });
  }

  onCancelCreate() {
    this.setState({ isModalConfirmOpen: false });
  }

  render() {
    const { reportsListData } = this.props;
    const { selectedReport, isModalConfirmOpen } = this.state;

    if (reportsListData.length === 0) {
      return null;
    }

    return (
      <div className={styles.controlReportPatternListContainer}>
        <Scrollbars style={{ height: "450px" }} autoHide={true} ref="scrollbar">
          {reportsListData
            .filter((report) => {
              return report.patternReport !== undefined && report.patternReport !== null && report.patternReport.customization;
            })
           /*  .filter((report) => {
              return report.buildType !== 2;
            }) */
            .map((report) => {
              return (
                <div
                  className={styles.routeReportPatternListItem}
                  key={report.id}
                  onClick={() => {
                    this.onSelected(report);
                  }}
                >
                  {report.title}
                  {selectedReport !== null && report.id === selectedReport.id ? (
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        this.onModalConfirmOpen();
                      }}
                      className={styles.createCustomReportButton}
                    >
                      Создать
                    </div>
                  ) : null}
                </div>
              );
            })}
        </Scrollbars>
        {selectedReport !== null ? (
          <ModalConfirmWindow isOpen={isModalConfirmOpen}>
            <ReportConstructorCreatePanel report={selectedReport} onCancelCreate={this.onCancelCreate.bind(this)} />
          </ModalConfirmWindow>
        ) : null}
      </div>
    );
  }
}

export default withCustomReport(withReportsList(React.memo(ReportConstructorPaternList)));
